/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */




const body = document.body;
const nav = document.querySelector("#shopify-section-header header");
const menu = document.querySelector("#shopify-section-header .Header__Wrapper");
const scrollUp = "scroll-up";
const scrollDown = "scroll-down";
const checkpoint = 150;
let lastScroll = 0;


window.addEventListener("scroll", () => {
  const currentScroll = window.pageYOffset;
  if (currentScroll <= checkpoint) {
    body.classList.remove(scrollUp);
    return;
  }

  if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
    // down
    body.classList.remove(scrollUp);
    body.classList.add(scrollDown);
  } else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
    // up
    body.classList.remove(scrollDown);
    body.classList.add(scrollUp);
  }
  lastScroll = currentScroll;
});


if ($('.owl-carousel').length > 0) {

  $('.owl-carousel').owlCarousel({
    loop: true,
    margin: 10,
    nav: true,
    autoplay: false,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 3
      },
      1000: {
        items: 4
      }
    }
  })
}


document.addEventListener('DOMContentLoaded', function () {
  const reviewsWidget = document.getElementById('judgeme_product_reviews');
  if (!reviewsWidget) return;

  function checkNoReviews() {
    if (reviewsWidget.querySelector('.jm-no-reviews-state')) {
      reviewsWidget.style.display = 'none';
    } else {
      reviewsWidget.style.display = '';
    }
  }

  // Initial check
  checkNoReviews();

  // Watch for class changes AND new nodes injected into the widget (Judge.me renders async)
  const observer = new MutationObserver(checkNoReviews);
  observer.observe(reviewsWidget, {
    attributes: true,
    attributeFilter: ['class'],
    childList: true,
    subtree: true,
  });
});

